(() => {
  const setActive = (section, swatch) => {
    if (!swatch) return;
    section.querySelectorAll('[data-swatch]').forEach(s => { s.classList.toggle('is-selected', s === swatch); s.setAttribute('aria-pressed', String(s === swatch)); });
    const name = section.querySelector('[data-swatch-name]');
    const desc = section.querySelector('[data-swatch-description]');
    const macro = section.querySelector('[data-swatch-macro]');
    const cta = section.querySelector('[data-swatch-cta]');
    if (name) name.textContent = swatch.dataset.name || '';
    if (desc) desc.textContent = swatch.dataset.description || '';
    if (cta && swatch.dataset.productUrl) cta.href = swatch.dataset.productUrl;
    if (macro && swatch.dataset.macro) {
      const current = macro.querySelector('img');
      const next = new Image();
      next.alt = swatch.dataset.name || '';
      next.decoding = 'async';
      next.onload = () => {
        if (current) current.style.opacity = '0';
        setTimeout(() => { macro.innerHTML = ''; macro.appendChild(next); requestAnimationFrame(() => next.style.opacity = '1'); }, 150);
      };
      next.style.opacity = '0';
      next.style.width = '100%'; next.style.height = '100%'; next.style.objectFit = 'cover'; next.style.transition = 'opacity .22s';
      next.src = swatch.dataset.macro;
    }
  };
  const setFamily = (section, family) => {
    section.querySelectorAll('[data-material-tab]').forEach(tab => tab.setAttribute('aria-selected', String(tab.dataset.materialTab === family)));
    const swatches = [...section.querySelectorAll('[data-swatch]')];
    swatches.forEach(s => s.hidden = s.dataset.family !== family);
    setActive(section, swatches.find(s => s.dataset.family === family));
  };
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-swatch-gallery]').forEach(section => {
      section.querySelectorAll('[data-material-tab]').forEach(tab => tab.addEventListener('click', () => setFamily(section, tab.dataset.materialTab)));
      section.querySelectorAll('[data-swatch]').forEach(swatch => swatch.addEventListener('click', () => setActive(section, swatch)));
      const firstTab = section.querySelector('[data-material-tab][aria-selected="true"]');
      if (firstTab) setFamily(section, firstTab.dataset.materialTab);
    });
  });
})();
